import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP4UnderUtilizedNew: FaireAdCampaignEntity = {
  token: "camp_p4_under_utilized_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_p4_under_utilized",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 14500,
  startedRunningAt: "2023-12-09",
  segmentMetrics: {
    numCustomersAcquired: 82,
    salesDollars: 59841,
    totalAdsSpendDollars: 8878,
    cpaDollars: 108,
    bestEstimateSalesDollars: 59841,
    bestEstimateRoas: 6.74,
  },
  topCustomers: [
    {
      retailerName: "Spirits & Soda Co.",
      storeType: "Specialty grocer",
      location: "Austin, TX",
      totalOrders: 2,
      totalAmountDollars: 980,
      lastOrderedAt: "2026-06-19",
    },
    {
      retailerName: "The Corner Bar Shop",
      storeType: "Gift shop",
      location: "Charleston, SC",
      totalOrders: 1,
      totalAmountDollars: 410,
      lastOrderedAt: "2026-05-02",
    },
  ],
  performancePeriodTokens: [
    "perf_p4_under_utilized_new_202510",
    "perf_p4_under_utilized_new_202511",
    "perf_p4_under_utilized_new_202512",
    "perf_p4_under_utilized_new_202601",
    "perf_p4_under_utilized_new_202602",
    "perf_p4_under_utilized_new_202603",
    "perf_p4_under_utilized_new_202604",
    "perf_p4_under_utilized_new_202605",
    "perf_p4_under_utilized_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
